import GeneralIcon from '../assets/general-icon.svg';
import GuideIcon from '../assets/guide-icon.svg';
import NewsIcon from '../assets/news-icon.svg';
import InvestigationIcon from '../assets/investigation-icon.svg';
import ProfileIcon from '../assets/profile-brown-icon.svg';
import FeatureIcon from '../assets/feature-icon.svg';
import OpEdIcon from '../assets/op-ed-icon.svg';
import ExplanatoryIcon from '../assets/explanatory-icon.svg';

export const CATEGORY_LIST_ICON = [
  {
    id: 1,
    icon: GeneralIcon,
    name: 'General'
  },
  {
    id: 2,
    icon: InvestigationIcon,
    name: 'Investigative'
  },
  {
    id: 3,
    icon: NewsIcon,
    name: 'Breaking News'
  },
  {
    id: 4,
    icon: FeatureIcon,
    name: 'Feature'
  },
  {
    id: 5,
    icon: OpEdIcon,
    name: 'Op-Ed'
  },
  {
    id: 6,
    icon: ProfileIcon,
    name: 'Profile'
  },
  {
    id: 7,
    icon: ExplanatoryIcon,
    name: 'Explanatory'
  },
  {
    id: 8,
    icon: GuideIcon,
    name: 'Guide'
  }
];

export const TAB_LIST_DASHBOARD = [
  {
    id: 1,
    name: 'Articles',
    value: 'articles'
  },
  {
    id: 2,
    name: 'Profile',
    value: 'profile'
  },
  {
    id: 3,
    name: 'Awarded Twigs',
    value: 'awarded-twigs'
  },
  {
    id: 4,
    name: 'Investments',
    value: 'investments'
  },
  {
    id: 5,
    name: 'My Investors',
    value: 'investors'
  },
  {
    id: 6,
    name: 'Requests',
    value: 'requests'
  },
  {
    id: 7,
    name: 'Submissions',
    value: 'submissions'
  }
];

export const TAB_LIST_DISCOVERY = {
  BREAKING: 'breaking',
  RECENT: 'recent',
  FOR_YOU: 'forYou',
  FOLLOWING: 'following',
  MY_READING: 'myReading',
  CATEGORIES: 'categories',
  NEWS_HUB: 'newsHub'
};

export const MODERATION_OPTIONS = {
  AI: 'ai',
  MODERATOR: 'moderator',
  USER_REPORTS: 'userReports'
};

export const MODERATION_TYPE = {
  SEXUAL: 'sexual',
  SEXUAL_MINORS: 'sexual minors',
  HARASSMENT: 'harassment',
  HARASSMENT_THREATENING: 'harassment threatening',
  HATE: 'hate',
  HATE_THREATENING: 'hate threatening',
  ILLICIT: 'illlicit',
  ILLICIT_VIOLENT: 'illlicit violent',
  SELF_HARM: 'self harm',
  SELF_HARM_INTENT: 'self harm intent',
  SELF_HARM_INSTRUCTIONS: 'self harm instructions',
  VIOLENCE: 'violence',
  VIOLENCE_GRAPHIC: 'violence graphic'
};

export const FORMATTED_VIOLATIONS = {
  SEXUAL: 'sexually explicit material',
  SEXUAL_MINORS: 'sexual content involving minors',
  HARASSMENT: 'harassing content',
  HARASSMENT_THREATENING: 'threatening or harassing content',
  HATE: 'hateful speech or imagery',
  HATE_THREATENING: 'threatening hateful content',
  ILLICIT: 'illicit material',
  ILLICIT_VIOLENT: 'violent illicit material',
  SELF_HARM: 'content related to self-harm',
  SELF_HARM_INTENT: 'expressions of self-harm intent',
  SELF_HARM_INSTRUCTIONS: 'instructions for self-harm',
  VIOLENCE: 'violent content',
  VIOLENCE_GRAPHIC: 'graphically violent material'
};
